"use scrict";

global.$ = require("jquery");
var MobileDetect = require('mobile-detect');

global.md = new MobileDetect(window.navigator.userAgent);
var mainWidth;

global.remToPx = function(x){
  return (parseInt($('html').css('font-size')) * x);
}

var Macy = require('macy');
var Masonry = require('masonry-layout');


$(function(){
  vh();

  if($('.logo-animation').length>0) {
    initLogoAnimation();
  }

  $('.credits').on('click', function(e){
    e.preventDefault();
    $('a.credits').toggleClass('on');
    $('.footer').toggleClass('show-credits');
  });

  $('.lights').on('click', function(e){
    e.preventDefault();
    let pri = $('html').css('--primary');
    let sec = $('html').css('--secondary')
    $('html').css({
      '--primary' : sec,
      '--secondary' : pri,
    });
    $('meta[name="theme-color"]').attr('content', sec);
    $(this).toggleClass('on');

    var value = $(this).hasClass('on');

    localStorage.setItem('larshogstrom-lights', value);
  });

  $('.filter').on('click', function(e){
    e.preventDefault();
    var id = this.dataset.filter;
    $(this).siblings().removeClass('cur');
    $(this).addClass('cur');

    $('.project-block').shuffle();

    $('.filtered-count').remove();

    if(id!=='all') {
      $('.project-block').each(function(idx){
        if(this.dataset.tags.indexOf(id)>=0) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      var len = $('.project-block:visible').length;
      $('.filter.cur').append(`<span class="filtered-count"> (${len})</span>`);

      // var len = $('.project-block:visible').length;
      // $('.project-block:visible').each(function(idx, el){
      //   var t = this;
      //   setTimeout(function(){
      //     // $(t).stop().animate({'opacity' : 0}, 500);
      //     $(t).stop().slideUp(800);
          
      //     if(idx==len-1) {
      //       var inIdx = 0;
      //       $('.project-block').each(function(idx){
      //         var th = this;
      //         if(th.dataset.tags.indexOf(id)>=0) {
      //           inIdx++;
      //         }
      //         setTimeout(function(){
      //           if(th.dataset.tags.indexOf(id)>=0) {
      //             // $(th).show().animate({'opacity' : 1}, 500);
      //             $(th).slideDown(500);
      //           } else {
      //             $(th).hide();
      //           }
      //         }, 800 + inIdx * 80);
      //       });
            
      //     }
      //   }, idx * 50);
      // });
    } else {
      // var len = $('.project-block').length;
      $('.project-block').show();
      // setTimeout(function(){
      //   $('.project-block').slideDown(500);
      // },500);
    }

  });

  setTimeout(function(){
    $('body').addClass('in');

    // $('video').each(function(){
    //   if(this.paused) {
    //     $(this).addClass('paused');
    //   }
    // });
  }, 10);

  $(window).on('pageshow', function(){
    $(window).trigger('scroll');
    $('body').removeClass('out').addClass('in');
  });

  binds();

  $(window).on('pageshow', function(){
    treats();
  });
});

function initLogoAnimation(){
  $('.logo-animation').text('').addClass('init');
  // this.dataset.one
  typeLogo($('.logo-animation').get(0).dataset.one);
  // this.dataset.two
}

function typeLogo(text) {
  // console.log('typing logo');
  $('.logo-animation').each(function(){
    var t = $(this);
    
    if(text===0) {
      var curText = $(this).text();
      
      for(let i=0; i<curText.length; i++) {
        setTimeout(function(){
          $(t).text(curText.substring(0, curText.length-i-1));
          
          if(i==curText.length-1){
            if(curText!==$(t).get(0).dataset.one) {
              setTimeout(function(){
                typeLogo($(t).get(0).dataset.one);
              }, 100);
            } else {
              setTimeout(function(){
                typeLogo($(t).get(0).dataset.two);
              }, 100);
            }
          }
        }, i * 20);
      }
    } else {
      for(let i=0; i<text.length; i++) {
        setTimeout(function(){
          $(t).text(text.substring(0, i+1));

          if(i==text.length-1){
            setTimeout(function(){ typeLogo(0) }, 2000);
          }
        }, i * 30);
      }
    }
  });
}

function treats(){

  if($('html').hasClass('photoproject')) {
    $('.header a[href*="photo"]').addClass('cur');
  }

  if($('html').hasClass('project')) {
  
    if(window.location.href.indexOf('commercials')>=0) {
      $('.header a[href*="commercial"]').addClass('cur');
    }

    if(window.location.href.indexOf('films')>=0) {
      $('.header a[href*="film"]').addClass('cur');
    }
  }

  if($('.category-photo').length>0) {
    // var macyInstance = Macy({
    //   container: '.main--wrap',
    //   trueOrder: true,
    //   waitForImages: false,
    //   margin: remToPx(2),
    //   columns: 3,
    //   breakAt: {
    //       786: 2,
    //   }
    // });

    // init with element
    // var grid = document.querySelector('.main--wrap');
    global.msnry = new Masonry( '.main--wrap', {
      // options...
      itemSelector: '.photoproject',
      percentPosition: true,
      columnWidth: '.grid-size',
      gutter: window.innerWidth < 787 ? remToPx(1) : remToPx(2),
      transitionDuration: 0
    });
    
    $(window).on('resize', function(){
      if(msnry) msnry.destroy();

      global.msnry = new Masonry( '.main--wrap', {
        // options...
        itemSelector: '.photoproject',
        percentPosition: true,
        columnWidth: '.grid-size',
        gutter: window.innerWidth < 787 ? remToPx(1) : remToPx(2),
        transitionDuration: 0
      });
    });

    $('.photoproject img').each(function(idx){
      var t = this; 
      setTimeout(function(){
        t.onload = $(t).addClass('ok');
      }, 30 * idx);
    });
  }
}


function binds(){
  $('.photoproject body').on('click', function(e){
    if(e.target == $('body').get(0)) {
    $('body').addClass('out');
      setTimeout(function(){
        window.history.back();
      }, 400);
    }
  });

  $('.back--link').on('click', function(e){
    e.preventDefault();
    $('body').addClass('out');
      setTimeout(function(){
        window.history.back();
      }, 400);
  });

  
  // $('.home .main > a').on('click', function(){
  //   $(this).addClass('force-hov');
  // });

  $('a[href*="'+window.siteurl+'"]').on('click', function(e){
    if (!e) e = window.event;
    if (!e.shiftKey &&
      !e.altKey &&
      !e.ctrlKey &&
      !e.metaKey) {
        e.preventDefault();
        $('body').addClass('out');
        var href = $(this).attr('href');
        setTimeout(function(){
          window.location = href;
        }, 350);
      }
  });

  $('.home .header--nav .cur').unbind('click').on('click', function(e){
    e.preventDefault();
    var h = $('.main').position().top - $('.header--nav').outerHeight() - $('.filters').outerHeight()*.5;
    if(window.innerWidth < 786) {
      h -= 8;
    }

    $('html, body').stop().animate({
      'scrollTop' : h 
    }, 600);
  });

  $('.menu-button').on('click', function(e){
    e.preventDefault();
    $('.header').toggleClass('nav-in');
  });

  $('.mobile-menu').on('click', function(e){
    if(!$(e.target).is('a') && $(e.target).parents('a').length==0) {
      $('.header').removeClass('nav-in');
    }
  });

  // $('.main--wrap p').each(function(){
  //   var h = $(this).html();
  //   var svg = $('.logo > svg').clone();
  //   $(svg).css({
  //     'height': '0.65em',
  //     'margin-right': '0.15em',
  //     'vertical-align': '-0.05em',
  //   });
  //   svg = svg.get(0).outerHTML;
  //   h = h.replaceAll('<strong>mose</strong>', svg);
  //   $(this).html(h);
  // });

  if($('html').hasClass('project')) {
    $(window).on('scroll', function(){
      var top = $(window).scrollTop();
      // if(top > $('.projects').position().top + remToPx(8)){
      //   $('.banner').addClass('w');
      // } else {
      //   $('.banner').removeClass('w');
      // }

      if(top + window.innerHeight > document.scrollingElement.scrollHeight - remToPx(7)){
        $('.footer').addClass('d');
      } else {
        $('.footer').removeClass('d');
      }

      $('video:not(.ok)').each(function(){
        if(this.getBoundingClientRect().top < window.innerHeight * 2) {
          $(this).children().attr('src', $(this).children().attr('data-src'));
          this.load();
          $(this).addClass('ok');
          this.play()
        }
      });
    });

    /*
    $('.block--image img').on('click', function(){
      $('html').addClass('no-overflow');
      $('body').append('<div class="pop"><div class="pop--content"></div></div>');
      $('.pop--content').append($(this).clone());
      $('.pop').on('click', function(e){
        if(e.target==this) {
          $('.pop').remove();
        }
      });
    });
    */
  }

  // $(window).scroll(function(){
  //   for(var i=0;i<window.blocks.length;i++) {
  //     var t = window.blocks[i];
  //     var rect = t.getBoundingClientRect();

  //     var inview = rect.top < window.innerHeight*.7 && rect.bottom > 0;

  //     if(inview){
  //       $(t).addClass('in');

  //       if(t.isHero) {
  //         console.log('ishero');
  //         let offsetPrc = Math.min(1, $(window).scrollTop() / window.innerHeight);
  //         let offset = -(100 * offsetPrc);
  //         $(t).css({
  //           'transform' : `translateY(${offset}px)`
  //           // 'transform' : `translate3d(-50%, calc(-50% + ${offset}px), 0)`
  //         });
  //       }
  //     } else {
  //       $(t).removeClass('in');
  //     }

  //     if(window.blocks[i].hasSparkles) {
  //       if(inview && !window.blocks[i].activeSparkles) {
  //         $(window.blocks[i]).find('.sparkles').addClass('in');
  //         window.blocks[i].activeSparkles = true;
  //       } else if(!inview){
  //         $(window.blocks[i]).find('.sparkles').removeClass('in');
  //         window.blocks[i].activeSparkles = false;
  //       }
  //     }
  //   }
  // });
}

function vh(){
  window.vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${window.vh}px`);
  $('#menuhooks.mobonly').css('top', $('.nav').outerHeight());
}

function resize(){
  let newMainWidth = $('main').outerWidth();
  if(newMainWidth!==mainWidth || !md.mobile()){
    vh();
  }
  mainWidth = newMainWidth;
}

$(window).on('resize', resize);

/*
function textFits(){
  $('.textfit').each(function(){
      var tar = $(this).parent();

      var h = $(this).parent().outerHeight();
      var w = $(this).parent().outerWidth();

      $(this).css({
        // 'height' : parseInt(h),
        'width' : parseInt(w),
      });

      var t = this;
      setTimeout(function(){
        textFit(
          t,
          {
            multiLine: true,
            minFontSize: 12,
            maxFontSize: remToPx(2.25),
            widthOnly: true,
          }
        );
      },1);
  });
}

window.textFits = textFits;
*/


$.fn.shuffle = function() {

    var allElems = this.get(),
        getRandom = function(max) {
            return Math.floor(Math.random() * max);
        },
        shuffled = $.map(allElems, function(){
            var random = getRandom(allElems.length),
                randEl = $(allElems[random]).clone(true)[0];
            allElems.splice(random, 1);
            return randEl;
        });

    this.each(function(i){
        $(this).replaceWith($(shuffled[i]));
    });

    return $(shuffled);

};

